import { Injectable, signal } from '@angular/core';

export type ViewMode = 'list' | 'grid';

@Injectable({
  providedIn: 'root'
})
export class ViewModeService {
  private readonly STORAGE_KEY = 'advanced_search_view_mode';
  private readonly DEFAULT_VIEW_MODE: ViewMode = 'list';

  // Signal para gerenciar o modo de visualização
  private viewModeSignal = signal<ViewMode>(this.loadViewMode());

  // Expor o signal como readonly
  readonly viewMode = this.viewModeSignal.asReadonly();

  constructor() {
    // Carrega a preferência salva ao inicializar
    this.loadViewMode();
  }

  /**
   * Alterna entre os modos de visualização
   */
  toggleViewMode(): void {
    const currentMode = this.viewModeSignal();
    const newMode: ViewMode = currentMode === 'list' ? 'grid' : 'list';
    this.setViewMode(newMode);
  }

  /**
   * Define o modo de visualização
   */
  setViewMode(mode: ViewMode): void {
    this.viewModeSignal.set(mode);
    this.saveViewMode(mode);
  }

  /**
   * Retorna o modo de visualização atual
   */
  getCurrentViewMode(): ViewMode {
    return this.viewModeSignal();
  }

  /**
   * Carrega o modo de visualização do localStorage
   */
  private loadViewMode(): ViewMode {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (stored && (stored === 'list' || stored === 'grid')) {
        return stored as ViewMode;
      }
    } catch (error) {
      console.error('Erro ao carregar modo de visualização:', error);
    }
    return this.DEFAULT_VIEW_MODE;
  }

  /**
   * Salva o modo de visualização no localStorage
   */
  private saveViewMode(mode: ViewMode): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, mode);
    } catch (error) {
      console.error('Erro ao salvar modo de visualização:', error);
    }
  }
}
